export default [{
  path: '/mppay',
  name: 'MpPay',
  component: () => import('@/views/pay/MpPay')
}, {
  path: '/h5pay',
  name: 'H5Pay',
  component: () => import('@/views/pay/h5Pay')
}, {
  path: '/midaspay',
  name: 'MidasPay',
  component: () => import('@/views/pay/MidasPay')
}]
